export enum StatusManifestacaoAuditado {
  NaoIniciada = 1,
  EmElaboracao = 2,
  Enviado = 3,
  ComSugestoesAcatadas = 4,
  ComSugestoesNaoAcatadas = 5,
  SemSugestoes = 6
}
